<div class="heading" *ngIf="projectArticles?.length !== 0">{{ "NEWS_TAB.latest_newstab" | translate }}</div>
<div class="no-news-image" *ngIf="projectArticles?.length === 0">
  <img src="/assets/icons/no-news.svg">
</div>
<div class="no-news" *ngIf="projectArticles?.length === 0">{{ "NEWS_TAB.no_news_newstab" | translate }}</div>

<div class="articles-block">
  <div class="article-block" *ngFor="let projectArticle of projectArticles | slice : 0:paginationLimit" [class.new]="!projectArticle.has_been_read">
    <div class="article-image"><div [style.backgroundImage]="'url(' + projectArticle.image + ')'"></div></div>
    <div class="article-heading">{{ projectArticle.title[currentLang] }}</div>
    <div class="publication-date">{{projectArticle.date}}</div>
    <div class="description" [innerHTML]="projectArticle.content[currentLang]" *ngIf="screenWidth > 575 || projectArticle.read_more_clicked"></div>
    <div class="description" [innerHTML]="projectArticle.content[currentLang].slice(0, 200) + '...'" *ngIf="screenWidth <= 575 && !projectArticle.read_more_clicked"></div>
    <div class="read-more-less" *ngIf="screenWidth <= 575 && projectArticle.content[currentLang].length > 200">
      <div class="read-more" *ngIf="!projectArticle.read_more_clicked" (click)="toggleReadMore(projectArticle.id)">{{ "NEWS_TAB.read_more_newstab" | translate }}</div>
      <div class="read-more" *ngIf="projectArticle.read_more_clicked" (click)="toggleReadMore(projectArticle.id)">{{ "NEWS_TAB.read_less_newstab" | translate }}</div>
    </div>
  </div>
</div>

<button *ngIf="paginationLimit < projectArticles?.length" class="green sans-serif" (click)="showMore()">{{ "NEWS_TAB.see_more_newstab" | translate }}</button>
